export default "__VITE_ASSET__CCJPDws3__"